import { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldCheck, AlertTriangle } from "lucide-react";

export default function AuthVerify() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("verifying");
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setStatus("error"); setError("No sign-in token found in the link."); return; }
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/magic-verify`, { token })
      .then(({ data }) => {
        localStorage.setItem("yc_token", data.token);
        setStatus("ok");
        setTimeout(() => { window.location.href = "/"; }, 800);
      })
      .catch((e) => {
        setStatus("error");
        setError(e.response?.data?.detail || "Verification failed.");
      });
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--yc-bg)]" data-testid="auth-verify-page">
      <div className="bg-white border border-slate-200 rounded-lg p-10 text-center max-w-md w-full mx-4">
        <span className="brand-mark mx-auto">YC</span>
        {status === "verifying" && (
          <>
            <Loader2 className="h-6 w-6 animate-spin mx-auto mt-6 text-[var(--yc-navy)]" />
            <div className="font-heading font-semibold text-[var(--yc-navy)] mt-3">Signing you in…</div>
          </>
        )}
        {status === "ok" && (
          <>
            <ShieldCheck className="h-6 w-6 mx-auto mt-6 text-[var(--yc-emerald)]" />
            <div className="font-heading font-semibold text-[var(--yc-navy)] mt-3" data-testid="verify-success">Verified! Opening your workspace…</div>
          </>
        )}
        {status === "error" && (
          <>
            <AlertTriangle className="h-6 w-6 mx-auto mt-6 text-[var(--yc-rose)]" />
            <div className="font-heading font-semibold text-[var(--yc-navy)] mt-3">Sign-in link problem</div>
            <p className="text-sm text-slate-600 mt-2" data-testid="verify-error">{error}</p>
            <Link to="/login" className="inline-block mt-5 text-sm text-[var(--yc-emerald)] hover:underline">Back to login</Link>
          </>
        )}
      </div>
    </div>
  );
}
